// extracted by mini-css-extract-plugin
export default {"fwrkLogin":"UpdateProfile_fwrkLogin__pLNRX"};